export enum JobStatus {
  "loading",
  "loaded",
  "errorLoading",
  "saving",
  "saved",
  "errorSaving",
  "enrichmentsSaving",
  "enriching",
  "errorEnriching",
}

export enum FileMappingStatus {
  "loading",
  "loaded",
  "errorLoading",
  "saving",
  "saved",
  "errorSaving",
  "unset",
  "set",
}
